import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import "react-circular-progressbar/dist/styles.css";
import styled from "styled-components";
import PCContainer from "../../components/atoms/layout/pcContainer";
import LSRgDisplay02 from "./../../components/molecules/text/linSeedKr/Rg/lsRgDisplay02";
import LSRgH2HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH2HeadLine";
import LSRgH1HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import LSRgBody01 from "../../components/molecules/text/linSeedKr/Rg/lsRgBody01";
import MOContainer from "../../components/atoms/layout/moContainer";
import SelectBox from "../../components/organisms/SelectBox";
import LSRgCaption02 from "../../components/molecules/text/linSeedKr/Rg/lsRgCaption02";
import Pagination from "./../../components/molecules/pagination";
import useDisplay from "../../hooks/useDisplay";
import { route } from "../../router/route";
import { scrapSubTabList, tabList } from "./../../constant/myPageTab";
import ScrapApi from "../../api/scrap.api";
import { errorHandler } from "../../util/errorHandler";
import Empty from "../../components/molecules/empty";
import { fileUrl } from "../../api/api";
import { formatNumberWithCommas } from "../../util/formatNumber";
import { macOSCheck } from "../../util/macOSCheck";
import StyledCategoryItem from "../../components/molecules/button/styledCategoryItem";
import StyledSubCategoryItem from "../../components/molecules/button/styledSubCategoryItem";
import Loading from "../../components/templates/loading";
import { toast } from "react-toastify";

const MyPageScrap = () => {
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;

  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams(); // eslint-disable-line no-unused-vars

  const [scrapList, setScrapList] = useState([]);

  const [categoryList] = useState([
    {
      title: "금융 스터디",
      value: "금융 스터디",
    },
    {
      title: "영상 강의",
      value: "영상 강의",
    },
    {
      title: "컨설팅",
      value: "컨설팅",
    },
  ]);

  const categoryValue = useMemo(() => {
    const requestedCategory = searchParams.get("categoryValue");
    return categoryList.some((item) => item.value === requestedCategory)
      ? requestedCategory
      : "금융 스터디";
  }, [categoryList, searchParams]);

  const page = useMemo(() => {
    const requestedPage = Number(searchParams.get("page"));
    return Number.isInteger(requestedPage) && requestedPage > 0
      ? requestedPage
      : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 6, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
    first: false,
    last: false,
  });

  const [subMenuBoxOpen, setSubMenuBoxOpen] = useState(false);
  const [selectedSubMenu, setSelectedSubMenu] = useState(tabList[3].title);

  const [selectedSubMenuTabOpen, setSelectedSubMenuTabOpen] = useState(false);
  const [selectedSubMenuTab, setSelectedSubMenuTab] = useState(
    scrapSubTabList[0].title,
  );

  useEffect(() => {
    if (sessionStorage.getItem("isLogin") !== "true") {
      toast("로그인이 필요한 서비스입니다.");
      navigate(
        `${route.login}?returnUrl=${encodeURIComponent(route.my_page_scrap)}`,
        { replace: true },
      );
      return;
    }

    dataListFunc();
  }, [location]); // eslint-disable-line react-hooks/exhaustive-deps

  const [isLoading, setIsLoading] = useState(true);

  const dataListFunc = async () => {
    if (sessionStorage.getItem("isLogin") !== "true") return;

    try {
      setIsLoading(true);
      const data = {
        page: page,
        size: pagination.size,
      };

      let response;
      switch (categoryValue) {
        case "금융 스터디":
          data.lectureCategoryType = "FINANCE_STUDY";

          response = (await ScrapApi.getLectureScrapList(data)).data.data;
          break;

        case "영상 강의":
          data.lectureCategoryType = "PAID_LECTURE";

          response = (await ScrapApi.getLectureScrapList(data)).data.data;
          break;

        case "컨설팅":
          response = (await ScrapApi.getConsultingScrapList(data)).data.data;
          break;

        default:
          data.lectureCategoryType = "FINANCE_STUDY";

          response = (await ScrapApi.getLectureScrapList(data)).data.data;
          break;
      }

      const content = response?.content ?? [];
      setScrapList(
        content.filter((item) =>
          categoryValue === "컨설팅"
            ? item?.consultingMerch
            : item?.lectureVideo,
        ),
      );
      setPagination((prev) => ({
        ...prev,
        totalCount: response.totalCount,
        totalPages: Math.max(1, Math.ceil(response.totalCount / prev.size)),
      }));
    } catch (error) {
      errorHandler(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <HomeSection $isSmall={isSmall}>
      {isDesktop && (
        <PCContainer
          style={{
            flexDirection: "column",
            width: "100%",
            padding: isSmall ? "0px 20px" : "0px",
          }}
        >
          <LSRgDisplay02
            style={{
              color: "#000",
              marginBottom: 32,
            }}
          >
            👨‍💻 마이페이지
          </LSRgDisplay02>
          <div
            style={{
              display: "flex",
              width: "100%",
              height: "fit-content",
              gap: 30,
            }}
          >
            {/* 탭 영역 */}
            <TabContainer>
              {tabList.map((tab, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 16,
                  }}
                >
                  <StyledCategoryItem
                    onClick={() => navigate(tab.path)}
                    isActive={index === 3 ? true : false}
                    title={tab.title}
                  />

                  {index === 3 && (
                    <SubTabWrapper>
                      {scrapSubTabList.map((subTab, index) => (
                        <StyledSubCategoryItem
                          key={index}
                          onClick={() => {
                            navigate(subTab.path);
                          }}
                          title={subTab.title}
                          isActive={index === 0 ? true : false}
                        />
                      ))}
                    </SubTabWrapper>
                  )}
                </div>
              ))}
            </TabContainer>
            {/* 본문 영역 */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 30,
              }}
            >
              <ContentContainer>
                <ContentHeaderWrapper>
                  <LSRgDisplay02 style={{ color: "#000" }}>
                    스크랩한 강의
                  </LSRgDisplay02>
                  <ContentHeaderTabWrapper>
                    {categoryList.map((item, index) => {
                      return (
                        <ContentHeaderTab
                          onClick={() => {
                            navigate(
                              `${route.my_page_scrap}?page=1&categoryValue=${item.value}`,
                            );
                          }}
                          isActive={categoryValue === item.value ? true : false}
                          key={index}
                        >
                          <LSRgBody01
                            style={{
                              marginTop: macOSCheck() ? 0 : 2,
                              color:
                                categoryValue === item.value
                                  ? "#fff"
                                  : "#A4A8B1",
                            }}
                          >
                            {item.title}
                          </LSRgBody01>
                        </ContentHeaderTab>
                      );
                    })}
                  </ContentHeaderTabWrapper>
                </ContentHeaderWrapper>

                {/* 본문 영역 - 강의 리스트 */}
                <ContentBodyWrapper>
                  {isLoading ? (
                    <Loading />
                  ) : scrapList.length > 0 ? (
                    scrapList.map((item, index) => (
                      <LectureWrapper
                        key={item.id}
                        onClick={() => {
                          if (categoryValue === "컨설팅") {
                            navigate(
                              `${route.consulting_detail}/${item.consultingMerch?.id}`,
                            );
                          } else {
                            navigate(
                              `${route.lecture_detail}/${item.lectureVideo?.id}`,
                            );
                          }
                        }}
                      >
                        <div
                          style={{
                            width: "100%",
                            height: isSmall ? "100px" : "308px",
                            borderRadius: 15,
                            overflow: "hidden",
                          }}
                        >
                          <LectureImg
                            src={
                              categoryValue === "컨설팅"
                                ? item.consultingMerch?.thumbnailServerFileName
                                  ? `${fileUrl}/${item.consultingMerch.thumbnailServerFileName}`
                                  : ""
                                : item.lectureVideo?.thumbnailServerFileName
                                  ? `${fileUrl}/${item.lectureVideo.thumbnailServerFileName}`
                                  : ""
                            }
                            alt="강의 이미지"
                          />
                        </div>
                        <LectureTextWrapper>
                          <LSRgH2HeadLine style={{ color: "#101113" }}>
                            {categoryValue === "컨설팅"
                              ? item.consultingMerch?.title
                              : item.lectureVideo?.title}
                          </LSRgH2HeadLine>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 14,
                              height: 22,
                            }}
                          >
                            {/* {categoryValue === "컨설팅" ? null : (
                              <>
                                <LSRgH1HeadLine
                                  style={{ marginTop: 2, color: "#6F7480" }}
                                >
                                  {item.lectureVideo?.slectureCategory?.title}
                                </LSRgH1HeadLine>
                                <LectureTextDivider />
                              </>
                            )} */}

                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 4,
                                height: 22,
                              }}
                            >
                              <img
                                style={{
                                  width: 16,
                                  height: 16,
                                  // marginBottom: 4,
                                }}
                                src={"/assets/icons/star_3d.png"}
                                alt="별점"
                              />
                              <LSRgH1HeadLine
                                style={{
                                  marginTop: macOSCheck() ? 0 : 2,
                                  color: "#6F7480",
                                }}
                              >
                                {categoryValue === "컨설팅"
                                  ? Number(
                                      item.consultingMerch?.reviewScore ?? 0,
                                    ).toFixed(1)
                                  : Number(
                                      item.lectureVideo?.reviewScore ?? 0,
                                    ).toFixed(1)}{" "}
                                (
                                {categoryValue === "컨설팅"
                                  ? formatNumberWithCommas(
                                      item.consultingMerch?.reviewCount,
                                    )
                                  : formatNumberWithCommas(
                                      item.lectureVideo?.reviewCount,
                                    )}
                                )
                              </LSRgH1HeadLine>
                            </div>
                          </div>
                        </LectureTextWrapper>
                      </LectureWrapper>
                    ))
                  ) : (
                    <Empty title="스크랩한 강의가 없습니다." />
                  )}
                </ContentBodyWrapper>

                {scrapList.length > 0 &&
                  pagination.totalCount > pagination.size && (
                    <Pagination
                      route={route.my_page_scrap}
                      queryString={`categoryValue=${categoryValue}`}
                      currentPage={Number(page) || 1}
                      totalPages={pagination.totalPages}
                      rangeSize={pagination.rangeSize}
                    />
                  )}
              </ContentContainer>
            </div>
          </div>
        </PCContainer>
      )}

      {/* ******************************** */}
      {/* ********** 모바일 버전 ********** */}
      {/* ******************************** */}
      {isSmall && (
        <MOContainer>
          <ContentContainer $isSmall={isSmall}>
            <ContentHeaderWrapper $isSmall={isSmall}>
              <LSRgH1HeadLine>👨‍💻 마이페이지</LSRgH1HeadLine>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <SelectBox
                  style={{ width: 158 }}
                  subMenuStyle={{ width: 158 }}
                  isSmall={true}
                  isOpen={subMenuBoxOpen}
                  isLink={true}
                  selectedValue={selectedSubMenu}
                  wrapperHandler={() => {
                    setSubMenuBoxOpen(!subMenuBoxOpen);
                  }}
                  itemList={tabList}
                  selectedValueSetterFunc={setSelectedSubMenu}
                />

                <SelectBox
                  style={{ width: 158 }}
                  subMenuStyle={{ width: 158 }}
                  isSmall={true}
                  isOpen={selectedSubMenuTabOpen}
                  isLink={true}
                  selectedValue={selectedSubMenuTab}
                  wrapperHandler={() => {
                    setSelectedSubMenuTabOpen(!selectedSubMenuTabOpen);
                  }}
                  itemList={scrapSubTabList}
                  selectedValueSetterFunc={setSelectedSubMenuTab}
                />
              </div>
            </ContentHeaderWrapper>

            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 20,
              }}
            >
              <LSRgH1HeadLine>스크랩한 강의</LSRgH1HeadLine>

              <ContentHeaderTabWrapper $isSmall={isSmall}>
                {categoryList.map((item, index) => {
                  return (
                    <ContentHeaderTab
                      onClick={() => {
                        navigate(
                          `${route.my_page_scrap}?page=1&categoryValue=${item.value}`,
                        );
                      }}
                      isActive={categoryValue === item.value ? true : false}
                      $isSmall={isSmall}
                      key={index}
                    >
                      <LSRgCaption02
                        style={{
                          color:
                            categoryValue === item.value ? "#fff" : "#A4A8B1",
                        }}
                      >
                        {item.title}
                      </LSRgCaption02>
                    </ContentHeaderTab>
                  );
                })}
              </ContentHeaderTabWrapper>
            </div>

            {/* 본문 영역 - 강의 리스트 */}
            <ContentBodyWrapper $isSmall={isSmall}>
              {isLoading ? (
                <Loading />
              ) : scrapList.length > 0 ? (
                scrapList.map((item, index) => (
                  <LectureWrapper
                    key={item.id}
                    $isSmall={isSmall}
                    onClick={() => {
                      if (categoryValue === "컨설팅") {
                        navigate(
                          `${route.consulting_detail}/${item.consultingMerch?.id}`,
                        );
                      } else {
                        navigate(
                          `${route.lecture_detail}/${item.lectureVideo?.id}`,
                        );
                      }
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        height: isSmall ? "100px" : "308px",
                        borderRadius: 15,
                        overflow: "hidden",
                      }}
                    >
                      <LectureImg
                        $isSmall={isSmall}
                        src={
                          categoryValue === "컨설팅"
                            ? item.consultingMerch?.thumbnailServerFileName
                              ? `${fileUrl}/${item.consultingMerch.thumbnailServerFileName}`
                              : ""
                            : item.lectureVideo?.thumbnailServerFileName
                              ? `${fileUrl}/${item.lectureVideo.thumbnailServerFileName}`
                              : ""
                        }
                        alt="강의 이미지"
                      />
                    </div>
                    <LectureTextWrapper $isSmall={isSmall}>
                      <LSRgH1HeadLine style={{ color: "#101113" }}>
                        {categoryValue === "컨설팅"
                          ? item.consultingMerch?.title
                          : item.lectureVideo?.title}
                      </LSRgH1HeadLine>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 4,
                          height: 22,
                        }}
                      >
                        <img
                          style={{
                            width: 16,
                            height: 16,
                            // marginBottom: 4,
                          }}
                          src={"/assets/icons/star_3d.png"}
                          alt="별점"
                        />
                        <LSRgCaption02 style={{ color: "#6F7480" }}>
                          {categoryValue === "컨설팅"
                            ? Number(
                                item.consultingMerch?.reviewScore ?? 0,
                              ).toFixed(1)
                            : Number(
                                item.lectureVideo?.reviewScore ?? 0,
                              ).toFixed(1)}{" "}
                          (
                          {categoryValue === "컨설팅"
                            ? formatNumberWithCommas(
                                item.consultingMerch?.reviewCount,
                              )
                            : formatNumberWithCommas(
                                item.lectureVideo?.reviewCount,
                              )}
                          )
                        </LSRgCaption02>
                      </div>
                    </LectureTextWrapper>
                  </LectureWrapper>
                ))
              ) : (
                <Empty title="스크랩한 강의가 없습니다." />
              )}
            </ContentBodyWrapper>

            {scrapList.length > 0 &&
              pagination.totalCount > pagination.size && (
                <Pagination
                  route={route.my_page_scrap}
                  queryString={`categoryValue=${categoryValue}`}
                  currentPage={Number(page) || 1}
                  totalPages={pagination.totalPages}
                  rangeSize={pagination.rangeSize}
                />
              )}
          </ContentContainer>
        </MOContainer>
      )}
    </HomeSection>
  );
};

export default MyPageScrap;

const HomeSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: ${(props) =>
    props.$isSmall ? "40px 0px 80px 0px" : "80px 0px 150px 0px"};
`;

const TabContainer = styled.div.attrs((props) => {})`
  width: 175px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const SubTabWrapper = styled.div.attrs((props) => {})`
  width: 175px;
  height: fit-content;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: -6px;
`;

const ContentContainer = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  height: fit-content;
  display: flex;
  flex-direction: column;
`;

const ContentHeaderWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: ${(props) => (props.$isSmall ? "stretch" : "center")};
  justify-content: space-between;
  flex-direction: ${(props) => (props.$isSmall ? "column" : "row")};
  gap: ${(props) => (props.$isSmall ? "16px" : "0px")};
  margin-bottom: ${(props) => (props.$isSmall ? "40px" : "30px")};
`;

const ContentHeaderTabWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  gap: ${(props) => (props.$isSmall ? "6px" : "10px")};
`;

const ContentHeaderTab = styled.button.attrs((props) => {})`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  height: ${(props) => (props.$isSmall ? "22px" : "36px;")};
  padding: ${(props) => (props.$isSmall ? "0px 14px" : "8px 14px;")};
  border-radius: 8px;
  border: ${(props) => !props.isActive && "1px solid #A4A8B1"};
  background-color: ${(props) => (props.isActive ? "#5050FF" : "#fff")};
`;

const ContentBodyWrapper = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  display: flex;
  flex-wrap: wrap;
  column-gap: ${(props) => (props.$isSmall ? "19px" : "29px")};
  row-gap: ${(props) => (props.$isSmall ? "20px" : "30px")};
`;

const LectureWrapper = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "158px" : "483px")};
  min-height: ${(props) => (props.$isSmall ? "180px" : "375px")};
  display: flex;
  flex-direction: column;
  gap: 16px;
  cursor: pointer;

  border-radius: ${(props) => (props.$isSmall ? "10px" : "15px")};

  &:hover img {
    transform: scale(1.04); /* 이미지 확대 */
    transition:
      transform 0.3s ease-in-out,
      filter 0.3s ease; /* 부드러운 애니메이션 */
  }
`;

const LectureImg = styled.img.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "158px" : "483px")};
  height: ${(props) => (props.$isSmall ? "100px" : "308px")};
  object-fit: cover;
  border-radius: ${(props) => (props.$isSmall ? "10px" : "15px")};
  transition:
    transform 0.3s ease,
    filter 0.3s ease; /* 기본 상태의 애니메이션 */
`;

const LectureTextWrapper = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "158px" : "483px")};
  display: flex;
  flex-direction: column;
  gap: ${(props) => (props.$isSmall ? "5px" : "4px")};
`;
